import { css } from "@compiled/react";

import { Image, ImageProps } from "../../../../components/wpl/image/src";

const customerSectionStyles = css({
    "justifyContent": "center",
    "alignItems": "center",
    "textAlign": "center",
    "padding": "1rem 0 2rem",

    "@media only screen and (min-width: 768px)": {
        paddingBlockStart: "4rem",
        paddingBlockEnd: "4rem"
    }
});

const h3Styles = css({
    "fontSize": "24px",
    "lineHeight": "1.33333333",
    "fontWeight": "500",
    "color": "#253858",
    "padding": "1rem 1rem 2rem",
    "marginBlock": "unset",
    "textWrap": "balance",

    "@media only screen and (min-width: 768px)": {
        fontSize: "36px"
    }
});

const containerStyles = css({
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "gap": "32px 40px",
    "alignItems": "center",
    "textAlign": "center",
    "flexWrap": "wrap",
    "marginInline": "auto",
    "maxWidth": "1200px",
    "padding": "0",

    "@media only screen and (min-width: 768px)": {
        flexDirection: "row",
        alignItems: "stretch",
        padding: "1rem"
    }
});

const imageStyles = css({
    "height": "45px",
    "@media only screen and (min-width: 768px)": {
        height: "35px"
    }
});

export interface PaidSocialProofProps {
    headerText: string;
    logos: ImageProps[];
}

export const PaidSocialProof = ({
    headerText,
    logos
}: PaidSocialProofProps) => {
    return (
        <section css={customerSectionStyles}>
            <h3 css={h3Styles}>{headerText}</h3>
            <div css={containerStyles}>
                {logos.map((inlineLogo, index) => (
                    <Image key={index} css={imageStyles} {...inlineLogo} />
                ))}
            </div>
        </section>
    );
};
